// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRP_header__3KFSO","image-wrapper":"infoRP_image-wrapper__eHBCk"};